const PAYMENT_STATUS = Object.freeze({
  PAID: "PAID",
  UN_PAID: "UN_PAID",
  TO_CHECK: "TO_CHECK",
});

export default PAYMENT_STATUS;
